import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoanDropdownOpen, setIsLoanDropdownOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const loanTypes = [
    { name: 'Personal Loan', path: '/personal-loan' },
    { name: 'Home Loan', path: '/home-loan' },
    { name: 'Loan Against Property', path: '/lap' },
    { name: 'Gold Loan', path: '/gold-loan' }
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_persian-indigo-fin/artifacts/d9xink6u_2897_Logo_V-PNG-01.png" 
              alt="PFIL Finance Logo" 
              className="h-36 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors ${
                isActive('/') ? 'border-b-2' : ''
              }`}
              style={{ borderColor: isActive('/') ? '#340C7F' : 'transparent' }}
            >
              Home
            </Link>

            <Link
              to="/about"
              className={`text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors ${
                isActive('/about') ? 'border-b-2' : ''
              }`}
              style={{ borderColor: isActive('/about') ? '#340C7F' : 'transparent' }}
            >
              About
            </Link>

            {/* Loans Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setIsLoanDropdownOpen(true)}
              onMouseLeave={() => setIsLoanDropdownOpen(false)}
            >
              <button className="text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium flex items-center transition-colors">
                Loans
                <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              
              {isLoanDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-md shadow-lg border border-gray-200 py-2">
                  {loanTypes.map((loan, index) => (
                    <Link
                      key={index}
                      to={loan.path}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                      style={{ '&:hover': { backgroundColor: '#340C7F', color: 'white' } }}
                    >
                      {loan.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/contact"
              className={`text-gray-700 hover:text-gray-900 px-3 py-2 text-sm font-medium transition-colors ${
                isActive('/contact') ? 'border-b-2' : ''
              }`}
              style={{ borderColor: isActive('/contact') ? '#340C7F' : 'transparent' }}
            >
              Contact
            </Link>

            <Link
              to="/contact"
              className="text-white px-6 py-2 rounded-full text-sm font-medium hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#340C7F' }}
            >
              Apply Now
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-gray-900 focus:outline-none"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-gray-100">
              <Link
                to="/"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>

              <Link
                to="/about"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900"
                onClick={() => setIsOpen(false)}
              >
                About
              </Link>
              
              {loanTypes.map((loan, index) => (
                <Link
                  key={index}
                  to={loan.path}
                  className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900"
                  onClick={() => setIsOpen(false)}
                >
                  {loan.name}
                </Link>
              ))}

              <Link
                to="/contact"
                className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-gray-900"
                onClick={() => setIsOpen(false)}
              >
                Contact
              </Link>

              <Link
                to="/contact"
                className="block px-3 py-2 text-center text-white rounded-full font-medium mx-3 mt-4"
                style={{ backgroundColor: '#340C7F' }}
                onClick={() => setIsOpen(false)}
              >
                Apply Now
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;